import http from "./httpService";
import JwtDecode from "jwt-decode";

const apiEndPoint = "/auth";
http.setJwt(getJwt());

export async function loginUser(email, password) {
  const { data: jwt } = await http.post(apiEndPoint, { email, password });
  localStorage.setItem("token", jwt);
}

export function loginWithJwt(jwt) {
  localStorage.setItem("token", jwt);
}

export function logout() {
  localStorage.removeItem("token");
}

export function getCurrentUser() {
  try {
    const jwt = localStorage.getItem("token");
    return JwtDecode(jwt);
  } catch (ex) {
    return null;
  }
}
export function getJwt() {
  return localStorage.getItem("token");
}

export default {
  loginUser,
  loginWithJwt,
  logout,
  getJwt,
  getCurrentUser,
};
